import React from "react";
import PropTypes from "prop-types";
import {
  isArrayEmpty,
  isNumberPositive,
  isStringEmpty,
} from "../../../../utils/handler_validations";
import styles from "./styles";
import { VeryIconGoogle } from "../VeryIconGoogle";
import { VeryLoading } from "../VeryLoading";
import { classVeryBtnOutlined } from "./classVeryBtnOutlined";

/**
 * Boton MUI background transparent con borde (texto + icon)
 */
export const VeryBtnOutlined = (
  props = classVeryBtnOutlined.propsTemplate()
) => {
  const theme = classVeryBtnOutlined.getColorTheme(
    props.colorTheme,
    props.isDisabled
  );
  const textSize = isNumberPositive(props.textSize)
    ? Number(props.textSize)
    : 16;

  const CSS = [];
  // add custom style
  if (!isArrayEmpty(props.CSS)) CSS.push(props.CSS);
  // add style theme
  if (!isStringEmpty(theme.className)) CSS.push(theme.className);
  // add class is loading
  if (props.isLoading === true) CSS.push("isLoading");

  return (
    <styles.divMain
      className={CSS.join(" ")}
      iconPosition={classVeryBtnOutlined.getIconPosition(props.icon?.position)}
      textSize={textSize}
      disabled={props.isDisabled === true}
      onClick={(event) => props.onClick && props.onClick()}
    >
      {props.isLoading === true ? (
        <VeryLoading
          color={theme.loadingColor}
          weight={4}
          size={props.icon?.size}
        />
      ) : (
        !isStringEmpty(props.icon?.name) && (
          <VeryIconGoogle
            CSS={["btnIcon"]}
            name={props.icon.name}
            type={props.icon.type}
            color={theme.iconColor}
            size={props.icon?.size}
          />
        )
      )}
      {!isStringEmpty(props.label) && (
        <label className="txtLabel">{props.label}</label>
      )}
    </styles.divMain>
  );
}
